<script setup lang="ts">
import { Tokens } from '~/utils/constants';
import tokens from 'public/img/tokens';

import Info from '~/components/icons/Info.vue';
import { addThousandSeparators } from '~/utils/formatters';

const tokenToPlay = defineModel<Tokens>('token');
const { isLoadingPusherStats } = defineProps<{ isLoadingPusherStats: boolean }>();

const tokenImage = computed(() => {
  return tokens[tokenToPlay.value || Tokens.pearl].toString();
});

const { data } = useNuxtData('pusherStats');

const handleTokenChange = (newToken: Tokens) => {
  tokenToPlay.value = newToken;
};
</script>

<template>
  <div
    class="pusher-stats"
    :class="{
      'pusher-stats-mobile': $device.isMobile
    }"
  >
    <span class="whiteMainTitle">{{ $t('coinPusherTotalStatisticStats') }}</span>

    <div class="currentPrizePool">
      <span class="whiteTitleBold">{{ $t('coinPusherTotalStatisticCurrentPrizePool') }}</span>

      <el-tooltip v-if="!$device.isMobile" placement="right" popper-class="popper-brown stats-tooltip">
        <template #content>
          <span>{{ $t('coinPusherTotalStatisticTooltip') }}</span>
        </template>
        <Info />
      </el-tooltip>
    </div>

    <UIPrizePool
      :value="addThousandSeparators(data.prizePool)"
      :token="tokenToPlay"
      :is-loading-data="isLoadingPusherStats"
      @token-change="handleTokenChange"
    />

    <hr />

    <div class="titleValueContainer">
      <span class="greyTitleBold">{{ $t('coinPusherTotalStatisticDistributedPrizePool') }}:</span>

      <div class="iconValueContainer" :class="{ 'ru-locale': $i18n.locale === 'ru' }">
        <img :src="tokenImage" class="img-md" alt="" />
        <span class="whiteTitle">{{ addThousandSeparators(data?.distributedPricePool) }}</span>
      </div>
    </div>

    <div class="titleValueContainer">
      <span class="greyTitleBold">{{ $t('coinPusherTotalStatisticTotalParticipants') }}:</span>
      <span class="whiteTitle">{{ addThousandSeparators(data?.playersCount) }}</span>
    </div>

    <div class="titleValueContainer">
      <span class="greyTitleBold">{{ $t('coinPusherTotalStatisticPlacedBets') }}:</span>
      <span class="whiteTitle">{{ addThousandSeparators(data?.placedBets) }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.pusher-stats {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.currentPrizePool {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
  margin-bottom: 7px;

  svg {
    padding-bottom: 0px;
  }
}

.titleValueContainer {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 16px;
  text-transform: lowercase;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;

  span:first-letter {
    text-transform: uppercase;
  }
}

.iconValueContainer {
  display: flex;
  align-items: center;

  .whiteTitle {
    height: 22px;
  }
}

.iconValueContainer.ru-locale {
  .whiteTitle {
    height: unset;
  }
}

.img-md {
  height: 32px;
  width: 32px;
  max-height: 32px;
  max-width: 32px;
}

hr {
  width: 300px;
  background-color: rgba(164, 150, 134, 1);
  height: 1px;
  border: none;
  margin: 24px 0 14px;
}

.info-icon {
  cursor: pointer;
  height: 20px;
  width: 20px;
  max-height: 20px;
}

.pusher-stats-mobile {
  hr {
    margin-top: 15px;
    width: 90%;
  }
}
</style>

<style lang="scss">
.el-popper.popper-brown.is-dark.stats-tooltip {
  max-width: 243px;
}
</style>
